import { useField } from 'formik';
import _ from 'lodash';
import { Box, Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Separator } from '@treams/treams-ui';

import EvaluationSubmissionAnswer from './EvaluationSubmissionAnswer';

export function EvaluationSubmissionReviewGoalDetail(props: {
	sectionIndex: number;
	itemIndex: number;
	goalID?: string;
	submission: graphql.EvaluationSubmission;
	fillInBy: { manager: boolean; employee: boolean };
	onSave: () => void;
	isSaving: boolean;
}) {
	const { localize } = useLocalize();

	const name = `sections[${props.sectionIndex}].items[${props.itemIndex}]`;

	const [{ value }] = useField<{
		type: graphql.EvaluationSectionItemType.ReviewGoals;
		reviewGoals?: graphql.EvaluationSubmissionItemReviewGoalInput[];
	}>(name);

	const goals = _.sortBy(props.submission.goals!, [
		(goal) => goal.status,
		(goal) => localize(goal.title).text.toLowerCase(),
	]);

	const goal = goals.find((goal) => goal.goal.id === props.goalID)!;

	const hasEmployeeReviewGoals =
		props.submission.employee.sections[props.sectionIndex].items[
			props.itemIndex
		]?.reviewGoals?.some(({ goalID }) => goalID === goal.goal.id) ?? false;

	const hasManagerReviewGoals =
		props.submission.manager.sections[props.sectionIndex].items[props.itemIndex]?.reviewGoals?.some(
			({ goalID }) => goalID === goal.goal.id,
		) ?? false;

	const index = value.reviewGoals?.findIndex(({ goalID }) => goalID === goal.goal.id) ?? -1;
	const enabled = index >= 0;

	return (
		<>
			{(enabled || hasEmployeeReviewGoals || hasManagerReviewGoals) && (
				<Flex>
					<Box flex={1} p={2}>
						<EvaluationSubmissionAnswer
							submission={props.submission}
							party={graphql.EvaluationSubmissionParty.Employee}
							itemIndex={props.itemIndex}
							goal={goal}
							sectionIndex={props.sectionIndex}
							onSave={props.onSave}
							isSaving={props.isSaving}
						/>
					</Box>

					<Separator vertical />

					<Box flex={1} p={2}>
						<EvaluationSubmissionAnswer
							submission={props.submission}
							party={graphql.EvaluationSubmissionParty.Manager}
							itemIndex={props.itemIndex}
							goal={goal}
							sectionIndex={props.sectionIndex}
							onSave={props.onSave}
							isSaving={props.isSaving}
						/>
					</Box>
				</Flex>
			)}
		</>
	);
}
